import React from 'react';
import { MessageCircle } from 'lucide-react';
import SEO from '../components/SEO';
import PageHero from '../components/PageHero';
import { useLanguage } from '../context/LanguageContext';

const Contact = () => {
  const { t } = useLanguage();

  return (
    <div style={styles.page}>
      <SEO titleKey="seo.contactTitle" descriptionKey="seo.contactDescription" />
      <PageHero
        image="https://images.unsplash.com/photo-1564013799919-ab600027ffc6?auto=format&fit=crop&w=1920&q=80"
        title={t('contact.title')}
        subtitle={t('contact.subtitle')}
        testIdTitle="contact-title"
      />

      <div style={styles.container}>
        <div style={styles.content}>
          <div style={styles.textSection}>
            <p style={styles.text}>{t('contact.intro')}</p>
          </div>

          <div style={styles.whatsappCard}>
            <MessageCircle size={64} color="#25D366" />
            <h2 style={styles.cardTitle}>{t('contact.whatsappContact')}</h2>
            <p style={styles.cardText}>{t('contact.whatsappText')}</p>
            <a
              href="https://wa.me/31644879415"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.whatsappButton}
              data-testid="contact-whatsapp-button"
            >
              <MessageCircle size={20} />
              {t('contact.startChat')}
            </a>
          </div>

          <div style={styles.infoSection}>
            <h3 style={styles.infoTitle}>{t('contact.helpWith')}</h3>
            <ul style={styles.list}>
              <li style={styles.listItem}>{t('contact.help1')}</li>
              <li style={styles.listItem}>{t('contact.help2')}</li>
              <li style={styles.listItem}>{t('contact.help3')}</li>
              <li style={styles.listItem}>{t('contact.help4')}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: '100vh',
    paddingBottom: '4rem',
  },
  header: {
    backgroundColor: '#E6DCCA',
    padding: '4rem 0',
    marginBottom: '4rem',
  },
  container: {
    maxWidth: '900px',
    margin: '0 auto',
    padding: '0 1.5rem',
  },
  title: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 'clamp(2.5rem, 5vw, 4rem)',
    color: '#1A1918',
    marginBottom: '1rem',
    textAlign: 'center',
  },
  subtitle: {
    color: '#585755',
    fontSize: '1.1rem',
    textAlign: 'center',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '3rem',
  },
  textSection: {
    textAlign: 'center',
  },
  text: {
    color: '#585755',
    fontSize: '1.05rem',
    lineHeight: 1.8,
    marginBottom: '1.5rem',
  },
  whatsappCard: {
    backgroundColor: 'white',
    border: '1px solid #EAE5DD',
    padding: '4rem 2rem',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1.5rem',
  },
  cardTitle: {
    fontFamily: "'Playfair Display', serif",
    fontSize: '2rem',
    color: '#1A1918',
  },
  cardText: {
    color: '#585755',
    fontSize: '1rem',
  },
  whatsappButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.75rem',
    backgroundColor: '#25D366',
    color: 'white',
    padding: '1.25rem 2.5rem',
    fontSize: '0.875rem',
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
    textDecoration: 'none',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    fontWeight: 500,
  },
  infoSection: {
    backgroundColor: '#E6DCCA',
    padding: '2.5rem',
  },
  infoTitle: {
    fontFamily: "'Playfair Display', serif",
    fontSize: '1.5rem',
    color: '#1A1918',
    marginBottom: '1.5rem',
    textAlign: 'center',
  },
  list: {
    listStyle: 'none',
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
  },
  listItem: {
    color: '#585755',
    fontSize: '1rem',
    paddingLeft: '1.5rem',
    position: 'relative',
  },
};

export default Contact;
